/**
===================================================
Module: frontend.src.components.CreateProjectModal.tsx
Description: Modal component for creating new projects
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/
import React, { useState } from "react";
import { CreateProjectRequest } from "../types";

interface CreateProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (projectData: CreateProjectRequest) => void;
  isUploading: boolean;
}

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isUploading,
}) => {
  const [projectData, setProjectData] = useState<CreateProjectRequest>({
    name: "",
    description: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (projectData.name.trim()) {
      onSubmit(projectData);
      setProjectData({ name: "", description: "" });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">フォルダの作成</h2>
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">
                フォルダ名 <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-input"
                value={projectData.name}
                onChange={(e) =>
                  setProjectData({ ...projectData, name: e.target.value })
                }
                placeholder="フォルダ名を入力してください"
                required
                disabled={isUploading}
              />
            </div>

            <div className="form-group">
              <label className="form-label">説明</label>
              <textarea
                className="form-textarea"
                value={projectData.description}
                onChange={(e) =>
                  setProjectData({
                    ...projectData,
                    description: e.target.value,
                  })
                }
                placeholder="フォルダの説明を入力してください"
                rows={3}
                disabled={isUploading}
              />
            </div>
          </form>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={isUploading}
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="btn-primary"
              onClick={handleSubmit}
              disabled={isUploading || !projectData.name.trim()}
            >
              {isUploading ? "作成中..." : "作成"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectModal;
